import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createTextVNode as u, Fragment as c, Comment as o } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function y(n, e, t = "default") {
  const r = e[t];
  if (r === void 0)
    throw new Error(`[vueuc/${n}]: slot[${t}] is empty.`);
  return r();
}
function i(n, e = !0, t = []) {
  return n.forEach((r) => {
    if (r !== null) {
      if (typeof r != "object") {
        (typeof r == "string" || typeof r == "number") && t.push(u(String(r)));
        return;
      }
      if (Array.isArray(r)) {
        i(r, e, t);
        return;
      }
      if (r.type === c) {
        if (r.children === null)
          return;
        Array.isArray(r.children) && i(r.children, e, t);
      } else
        r.type !== o && t.push(r);
    }
  }), t;
}
function p(n, e, t = "default") {
  const r = e[t];
  if (r === void 0)
    throw new Error(`[vueuc/${n}]: slot[${t}] is empty.`);
  const f = i(r());
  if (f.length === 1)
    return f[0];
  throw new Error(`[vueuc/${n}]: slot[${t}] should have exactly one child.`);
}
export {
  i as flatten,
  p as getFirstVNode,
  y as getSlot
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/shared/v-node.js
// module id = 481
// module chunks = 41